import { render, staticRenderFns } from "./checkPaid.vue?vue&type=template&id=770e20ce&"
import script from "./checkPaid.vue?vue&type=script&lang=js&"
export * from "./checkPaid.vue?vue&type=script&lang=js&"
import style0 from "./checkPaid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports